import type { Action, AuthState, MainState, StoreState } from '../../framework/stateTypes'

const reducer = (state: StoreState, action: Action): StoreState => {
  switch (action.type) {
    case 'set-value':
      return { ...state, [action.key]: action.value }
    case 'set-values':
      return { ...state, ...action.values }
    case 'set-main-values':
      return { ...state, main: { ...state.main, ...action.values } as MainState }
    case 'set-auth-values':
      return { ...state, auth: { ...state.auth, ...action.values } as AuthState }
    case 'logout':
      return { ...state, loggingOut: true }
    default:
      throw new Error('unknown action')
  }
}

export default reducer
